import { Chip, RadioInput, Select } from '@mm/components';
import { TagFilterItem, TagFilterValue } from '@mm/state/model/AudiencesModel';
import { allTags } from '@mm/state/selectors/tags';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FilterBarItemContentProps } from './FilterBarItem';
import { FilterBarItemEditContainerButtons } from './FilterBarItemEditContainerButtons';

export const FilterBarTagFilter = ({
  editing,
  filter,
  onCancelEdit,
  onStartEdit,
  onUpdate,
  styles,
  className,
}: FilterBarItemContentProps<TagFilterItem>) => {
  const tags = useSelector(allTags);

  const [operator, setOperator] = useState<'include' | 'exclude'>(
    filter.operator,
  );
  const [selectedTagNames, setSelectedTagNames] = useState<string[]>(
    filter.values.map(value => value.name),
  );
  useEffect(() => {
    if (!editing) {
      setSelectedTagNames([]);
      return;
    }
    setOperator(filter.operator);
    setSelectedTagNames(filter.values.map(value => value.name));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editing]);
  const onDone = () => {
    onUpdate({
      ...filter,
      operator,
      values: tags.filter(
        t => t.kind && selectedTagNames?.includes(t.name),
      ) as TagFilterValue[],
    });
  };

  const [tagSearchQuery, setTagSearchQuery] = useState('');
  const tagOptions = tags
    .filter(t => t.name.toLowerCase().includes(tagSearchQuery))
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(t => ({ id: t.name, label: t.name }));
  const selectedTagOptions = tagOptions.filter(opt =>
    selectedTagNames.includes(opt.label),
  );

  return (
    <>
      {editing && (
        <div
          className={classNames(
            styles.editContainer,
            styles.editContainerWithGaps,
            className,
          )}
        >
          <strong>Choose filter type</strong>
          <div className={styles.operators}>
            <RadioInput
              checked={operator === 'include'}
              onChange={() => setOperator('include')}
              name="operator"
              value="include"
              label="Include"
            />
            <RadioInput
              checked={operator === 'exclude'}
              onChange={() => setOperator('exclude')}
              name="operator"
              value="exclude"
              label="Exclude"
            />
          </div>
          <div>Tags:</div>
          <Select
            placeholder="Select 1 or more tags"
            options={tagOptions}
            selected={selectedTagOptions}
            onSearch={query => setTagSearchQuery(query?.toLowerCase() || '')}
            onChange={option =>
              setSelectedTagNames(option.map(opt => String(opt.id)))
            }
          />
          {!!selectedTagNames.length && (
            <div className={styles.horizontalContainer}>
              {selectedTagNames.map(tagName => (
                <Chip
                  key={tagName}
                  text={tagName}
                  className={styles.tag}
                  iconProps={{
                    color: '#8c8c8c',
                    onClick: () =>
                      setSelectedTagNames(
                        selectedTagNames
                          .filter(name => name !== tagName)
                          .sort((a, b) => a.localeCompare(b)),
                      ),
                  }}
                />
              ))}
            </div>
          )}

          <FilterBarItemEditContainerButtons
            className={styles.editContainerButtons}
            disableDone={!selectedTagNames.length}
            onDone={onDone}
            onCancelEdit={onCancelEdit}
          />
        </div>
      )}

      <div onClick={onStartEdit} className={styles.content}>
        <strong>Tags:</strong>&nbsp;
        {!filter.values.length ? (
          <em>Select tag(s)</em>
        ) : (
          <>
            <span>{filter.operator === 'include' ? 'Include' : 'Exclude'}</span>
            &nbsp;
            {filter.values.map(value => value.name).join(', ')}
          </>
        )}
      </div>
    </>
  );
};
